export default "__VITE_ASSET__f33f3637__"